import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AbstractControl, FormBuilder, FormControl, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { InputModule } from 'src/app/common/input/input.module';
import { ButtonModule } from 'src/app/common/button/button.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { getAuth, signInWithPhoneNumber } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { environment } from 'src/environments/environment';
import { AuthService, EventsService, SignupService, StorageService, UtilService, VariablesService } from 'src/app/shared/services';
import { CaptchaModule } from 'src/app/common/captcha/captcha.module';
import { SelectModule } from 'src/app/common/select/select.module';
import { MatSliderModule } from '@angular/material/slider';

import { DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from 'src/app/shared/format-datepicker';

import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { HealthFirstService } from '../../services/health-first.service';

@Component({
  selector: 'app-hf-calculator-page',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    InputModule,
    ReactiveFormsModule,
    ButtonModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    CaptchaModule,
    SelectModule,
    MatSliderModule,
  ],
  providers: [
    {provide: DateAdapter, useClass: AppDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
  ],
  templateUrl: './hf-calculator-page.component.html',
  styleUrls: ['./hf-calculator-page.component.scss']
})
export class HfCalculatorPageComponent {
  info = {
    mobTitle: 'Calculate Your Savings',
    steps: [
      {
        topContent: {
          title: 'Enter basic details',
          subTitle: 'to help us calculate your medical expenses',
          desc: ''
        },
        bottomContent: {
          title: 'check your healthfirst plan',
          subTitle: 'in just few steps'
        }
      },
      {
        topContent: {
          title: 'we need basic details',
          subTitle: 'of your family member',
          desc: 'We\'re currently covering a family of 4 (2 adults and 2 children)'
        },
        bottomContent: {
          title: 'check your healthfirst plan',
          subTitle: 'in just few steps'
        }
      },
      {
        topContent: {
          title: 'Help us estimate',
          subTitle: 'your annual medical expenses',
          desc: ''
        },
        bottomContent: {
          title: 'you have completed',
          subTitle: '2/4 steps so far'
        }
      },
      {
        topContent: {
          title: 'Tell us a little more',
          subTitle: `about your family's habits so we can pick the right plan`,
          desc: ''
        },
        bottomContent: {
          title: 'keep going',
          subTitle: 'you\'re almost there'
        }
      }
    ],
    bottomSheet: {
      dob: {
        title: 'Select the date of birth',
        subTitle: 'they are right now'
      },
    }
  }
  step1Form;
  step2Form;
  step3Form;
  step4Form;
  step2Info = [
    { placeholder: 'Adult 1 Name', heightFt: 'in ft', heightInch: 'in Inch', weight: 'in kg' },
    { placeholder: 'Adult 2 Name', heightFt: 'in ft', heightInch: 'in Inch', weight: 'in kg' },
    { placeholder: 'Child 1 Name', heightFt: 'in ft', heightInch: 'in Inch', weight: 'in kg' },
    { placeholder: 'Child 2 Name', heightFt: 'in ft', heightInch: 'in Inch', weight: 'in kg' },
  ]
  isLoading = false;
  step = 0;
  dateCtrl = new FormControl();
  showDate = false;
  currentDate = new Date();
  oneHundredTwentyDate = new Date(this.currentDate.getFullYear() - 120, this.currentDate.getMonth(), this.currentDate.getDate());
  eighteenYearsBeforeToday = new Date(this.currentDate);
  extn = '+91';
  step2InfoArr = [
    { val: 0, isDateOpen: false, minDate: this.oneHundredTwentyDate, maxDate: this.eighteenYearsBeforeToday, title: 'Adult 1'},
    { val: 1, isDateOpen: false, minDate: this.oneHundredTwentyDate, maxDate: this.eighteenYearsBeforeToday, title: 'Adult 2' },
    { val: 2, isDateOpen: false, minDate: this.eighteenYearsBeforeToday, maxDate: new Date(), title: 'Children 1' },
    { val: 3, isDateOpen: false, minDate: this.eighteenYearsBeforeToday, maxDate: new Date(), title: 'Children 2' },
  ]
  sendOtpClicked = false;
  progressBarValue = 5;
  clinicalVisitOption = [
    { id: 1, label: '1 time',  value: '1' },
    { id: 2, label: '2 times',  value: '2' },
    { id: 3, label: '3 times',  value: '3' },
    { id: 4, label: '4 times',  value: '4' },
    { id: 5, label: '5 times',  value: '5' },
    { id: 6, label: 'more than 5 times',  value: 'more than 5 times' }
  ];
  yesOrNoOptions = [
    { id: 1, label: 'Yes', value: 'yes'},
    { id: 2, label: 'No', value: 'no' }
  ];
  bottomSheetType = '';

  dateOfBirthCtrl = new FormControl('');
  errorMessage = {
    required: 'This field is required',
    custom: 'Invalid number',
    email: 'Invalid email',
    maxLength: 'max character exceeds',
    max: '',
    min: '',
  }

  heightFtErrorMsg = {
    ...this.errorMessage,
    max: 'max is 9',
    custom: 'min is 1'
  }

  heightInchErrorMsg = {
    ...this.errorMessage,
    max: 'max is 11',
    custom: 'min is 0'
  }

  weightErrorMsg = {
    ...this.errorMessage,
    max: 'max is 200kg',
    custom: 'min is 1kg'
  }

  showOtp = false;
  showSignupForm = false;
  isNewUser = false;
  otpSentTo;
  firebase_response = '';

  @ViewChild('bottomSheetRef') bottomSheetRef;

  constructor(
    private events: EventsService,
    private fb: FormBuilder,
    private router: Router,
    public util: UtilService,
    private vars: VariablesService,
    private bottomSheet: MatBottomSheet,
    private hfService: HealthFirstService,
    private authService: AuthService,
    private signupService: SignupService,
    private actRoute: ActivatedRoute,
    private storage: StorageService
  ) {
    this.subs.push(this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (this.util.isMobile()) {
            this.vars.mainLayoutConfig.next({
              showFooter: false
            });
          }
          this.getUserData();
        }
      })
    );
  }
  subs = [];
  userData;

  ngOnInit() {
    this.initForm();
    this.eighteenYearsBeforeToday.setFullYear(this.currentDate.getFullYear() - 18);
    this.checkUser();
    this.onMobileChange();
    this.getParams();
    this.getUserData();
    if (typeof window !== 'undefined') {
      document.body.style.overflowX = 'unset';
    }
  }

  getUserData() {
    this.vars.userData.subscribe(val => {
      if (val) {
        this.userData = val;
        this.step = 1;
        this.patchData();
      }
    })
  }

  ngAfterViewInit() {
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        this.util.scrollToTop();
      }, 500);
    }
  }

  getParams() {
    const step = this.actRoute.snapshot.queryParams['step'];
    if(step) {
      this.step = +step;
    }
  }
  checkUser() {
    const user = this.storage.get('userdata');
    if (user) {
      this.getUserProfile();
    }
  }

  getUserProfile() {
    this.authService.getUserProfile().subscribe((val:any) => {
      if (val.data) {
        this.userData = val.data;
        this.vars.userData.next(val.data);
        this.step = 1;
        if (!this.step2Form.controls[0].get('name').value) {
          this.patchData();
        }
        this.util.setUserData(val.data);
      }
    })
  }

  patchData() {
    const health_details = this.userData?.health_details;
    if (health_details && health_details.length > 0) {
      const healthfirst_about_family = health_details.find(item => item.info_type === 'healthfirst_about_family');
      const healthfirst_about_habits = health_details.find(item => item.info_type === 'healthfirst_about_habits');
      const healthfirst_medical_expense = health_details.find(item => item.info_type === 'healthfirst_medical_expense');

      if (healthfirst_about_family) {
        this.patchForm('family', healthfirst_about_family);
      } else {
        this.patchLoginUserData();
      }
      if (healthfirst_about_habits) {
        this.patchForm('habits', healthfirst_about_habits);
      }
      if (healthfirst_medical_expense) {
        this.patchForm('medical', healthfirst_medical_expense);
      }
    } else {
      this.patchLoginUserData();
    }
  }

  patchLoginUserData() {
    if (!this.userData) {
      this.userData = this.util.getUserData();
    }

    if (this.userData && 'full_name' in this.userData) {
      this.step2Form.controls[0].get('name').patchValue(this.userData.full_name);
    }

    if (this.userData && 'age' in this.userData) {
      if (this.util.isValidDate(this.userData.age)) {
        this.step2Form.controls[0].get('age').patchValue(this.userData.age);
        this.step2InfoArr[0].isDateOpen = true;
      }
    }
  }

  patchForm(type, patchData) {
    const cases = {
      family: () => {
        if (patchData) {
          if (typeof patchData.info_1 === 'string') {
            patchData.info_1 = JSON.parse(patchData.info_1);
          }
          if (Array.isArray(patchData.info_1)) {  
            patchData.info_1.forEach((item, index) => {
              this.step2Form.controls[index].get('name').patchValue(item.name || '');
              if (item.dob) {
                this.step2InfoArr[index].isDateOpen = true;
                this.step2Form.controls[index].get('age').patchValue(item.dob || '');
              }
              if (item.height) {
                const [heightFt, heightInch] = item.height.split('.');
                this.step2Form.controls[index].get('heightFt').patchValue(+heightFt);
                this.step2Form.controls[index].get('heightInch').patchValue(+heightInch);
              }
              this.step2Form.controls[index].get('weight').patchValue(item.weight || '');
            })
          } else {
            this.step2Form.controls[0].get('name').patchValue(patchData.info_1.name);
            this.step2InfoArr[0].isDateOpen = true;
            this.step2Form.controls[0].get('age').patchValue(patchData.info_1.dob);
            const [heightFt, heightInch] = patchData.info_1.height.split('.');
            this.step2Form.controls[0].get('heightFt').patchValue(+heightFt);
            this.step2Form.controls[0].get('heightInch').patchValue(+heightInch);
            this.step2Form.controls[0].get('weight').patchValue(patchData.info_1.weight);
          }
        }
      },
      habits: () => {
        if (patchData) {
          if (typeof patchData.info_1 === 'string') {
            patchData.info_1 = JSON.parse(patchData.info_1);
          }
          this.step4Form.get('anySmoker').patchValue(patchData.info_1.does_anyone_in_your_family_smokes);
          this.step4Form.get('anyDrinker').patchValue(patchData.info_1.any_drinkers_in_your_family);
          this.step4Form.get('anyTobacco').patchValue(patchData.info_1.anyone_in_the_family_using_tobacco);
        }
      },
      medical: () => {
        if (patchData) {
          if (typeof patchData.info_1 === 'string') {
            patchData.info_1 = JSON.parse(patchData.info_1);
          }
          this.step3Form.get('avgSpendsOnMedicine').patchValue(patchData.info_1.avg_spends_on_medical);
          this.step3Form.get('annualClinicVisit').patchValue(patchData.info_1.annual_clinic_visits);
          this.step3Form.get('avgSpendsOnLabTest').patchValue(patchData.info_1.avg_spends_on_lab_test);
        }
      }
    }
    cases[type]();
  }

  minNumValidator(minVal) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value && control.value < minVal) {
        return { custom: true };
      }
      return null;
    }
  }

  initForm() {
    this.step1Form = this.fb.group({
      mobile: ['', [Validators.required, this.minNumValidator(10), Validators.minLength(10)]],
      otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6), this.minNumValidator(1)]],
      name: ['', [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i)]],
      email: ['', [Validators.required, Validators.pattern(this.vars.email_Pattern_Regex)]]
    });

    this.step1Form.get('otp').disable();
    this.step1Form.get('name').disable();
    this.step1Form.get('email').disable();

    this.step2Form = this.fb.array([
      this.fb.group({
        name: ['', Validators.required],
        age: ['', Validators.required],
        heightFt: [null, [Validators.required, this.minNumValidator(1), Validators.max(9)]],
        heightInch: [null, [Validators.required, this.minNumValidator(0), Validators.max(11)],],
        weight: ['', [Validators.required, this.minNumValidator(1), Validators.max(200)]]
      }),
      this.fb.group({
        name: ['',],
        age: ['',],
        heightFt: [null, [this.minNumValidator(1), Validators.max(9)]],
        heightInch: [null, [this.minNumValidator(0), Validators.max(11)]],
        weight: ['',[this.minNumValidator(1), Validators.max(200)]],
      }),
      this.fb.group({
        name: ['',],
        age: ['',],
        heightFt: [null, [this.minNumValidator(1), Validators.max(9)]],
        heightInch: [null, [this.minNumValidator(0), Validators.max(11)]],
        weight: ['',[this.minNumValidator(1), Validators.max(200)]],
      }),
      this.fb.group({
        name: ['',],
        age: ['',],
        heightFt: [null, [this.minNumValidator(1), Validators.max(9)]],
        heightInch: [null, [this.minNumValidator(0), Validators.max(11)]],
        weight: ['',[this.minNumValidator(1), Validators.max(200)]],
      })
    ]);
    this.step3Form = this.fb.group({
      avgSpendsOnMedicine: ['', [Validators.required, this.minNumValidator(1)]],
      annualClinicVisit: ['', Validators.required],
      avgSpendsOnLabTest: ['', [Validators.required, this.minNumValidator(1)]]
    });
    this.step4Form = this.fb.group({
      anySmoker: [null, Validators.required],
      anyDrinker: [null, Validators.required],
      anyTobacco: [null, Validators.required]
    });
  }

  getBtnClass() {
    if (this.step === 0) {
      return 'hf-primary-btn continue-btn mat-elevation-z0'+ (this.step1Form.invalid || !this.sendOtpClicked ? ' disabled ': '');
    } else if (this.step === 1) {
      return 'hf-primary-btn continue-btn mat-elevation-z0'+ (this.step2Form.invalid ? ' disabled ': '')
    } else if (this.step === 2){
      return 'hf-primary-btn continue-btn mat-elevation-z0'+ (this.step3Form.invalid ? ' disabled ': '');
    } else {
      return 'hf-primary-btn continue-btn mat-elevation-z0'+ (this.step4Form.invalid ? ' disabled ': '');
    }
  }

  getDisableStateContdBtn() {
    if (this.step === 0) {
      return this.step1Form.invalid || !this.sendOtpClicked;
    }
  }

  onBackBtnClicked() {
    if (this.step !== 0) {
      if (this.step === 1 && Object.keys(this.userData).length > 0) {
        this.router.navigate(['/healthfirst']);
      } else {
        this.step = this.step - 1;
        const stepfn = {
          0: 5,
          1: 30,
          2: 70,
          3: 90
        }
        this.progressBarValue = stepfn[this.step];
      }
    } else { 
      this.router.navigate(['/healthfirst']);
    }
  }

  onContinueClicked() {
    this.checkForm().then(val => {
      if (val && this.step <= 3 && this.step > 0) {
        this.sendLeadData().then(val => {
          if (val) {
            if (this.step === 3) {
              this.submitForm();
            } else {
              this.incrementStep();
            }
          } else {
            this.util.openSnackBar('Something went wrong!', 'DISMISS');
          }
        });
      } else if (val && this.step === 0) {
        if (!this.step1Form.valid) {
          this.step1Form.markAllAsTouched();
          return;
        }
        if (this.showOtp) {
          this.verifyOtp();
        } else {
          this.verifyUserDetails();
        }
      }
    });
  }

  sendLeadData() {
    return new Promise((resolve, reject) => {
      let payload = {
        info_1: '',
        info_type: ''
      };
      const cases = {
        1: () =>  {
          let values = this.step2Form.value;
          if (values.length > 0) {
            const payload = [];
            values = values.map(item => {
              if (item.name === '') {
                item.name = null
              }
              if (item.age === '' || (typeof item.age === 'undefined')) {
                item.age = null;
              }
              if (item.heightFt === '' || (typeof item.heightFt === 'undefined')) {
                item.heightFt = null;
              }
              if (item.heightInch === '' || (typeof item.heightInch === 'undefined')) {
                item.heightInch = null;
              }
              if (item.weight === '' || (typeof item.weight === 'undefined')) {
                item.weight = null;
              }
              return item;
            })
            values.forEach(value => {
              let height = null;
              if (value.heightFt && value.heightInch) {
                height = value.heightFt + '.' + value.heightInch;
              }
              let dob = null; 
              if (value.age) {
                dob = this.util.formatDateToYYYYMMDD(value.age);
              }
              payload.push({
                name: value.name,
                dob,
                height,
                weight: value.weight
              });
            });
            return JSON.stringify(payload);
          }
        },
        2: () => {
          const payload = {
            avg_spends_on_medical: this.step3Form.get('avgSpendsOnMedicine').value,
            annual_clinic_visits: this.step3Form.get('annualClinicVisit').value,
            avg_spends_on_lab_test: this.step3Form.get('avgSpendsOnLabTest').value
          }
          return JSON.stringify(payload);
        },
        3: () => {
          const payload = {
            does_anyone_in_your_family_smokes: this.step4Form.get('anySmoker').value,
            any_drinkers_in_your_family: this.step4Form.get('anyDrinker').value,
            anyone_in_the_family_using_tobacco: this.step4Form.get('anyTobacco').value
          }
          return JSON.stringify(payload);
        },
      }

      const cases2 = {
        1: () => 'about_family',
        2: () => 'medical_expense',
        3: () => 'about_habits'
      }
      payload = { info_1: cases[this.step](), info_type: `healthfirst_${cases2[this.step]()}`};
      this.hfService.sendLeadData(payload).subscribe({next: val => {
        if (val) {
          this.vars.pageName = 'healthfirst_calculator';
          this.sendEvent({
            eventName: 'step_completed',
            page_name: 'healthfirst_calculator',
            info_1: `step ${this.step}`
          });
          this.events.claverTapPush('Healthfirst calculator step', {
            'Event name': 'step_completed',
            'info_1': `step ${this.step}`,
          });
          resolve(true);
        }
      },error: error => {
          console.log(error);
          resolve(false);
        }
      });
    });
  }

  verifyOtp() {
    if (this.util.isBrowser) {
      this.isLoading = true;
      (<any>window).confirmationResult.confirm(this.step1Form.get('otp').value).then(result => {
        result.user.getIdToken().then((idToken) => {
          this.isLoading = false;
          this.step2Form.controls[0].get('name').patchValue(this.step1Form.get('name').value);
          this.firebase_response = result.user;
          if (this.showSignupForm) {
            this.registerUser();
          } else {
            this.verifyUserToken();
          }
        });
      }).catch(error => {
        this.isLoading = false;
        this.util.openSnackBar((/invalid-verification-code/).test(error.message) ? 'Invalid OTP' : error.message, 'error');
      });
    }
  }

  verifyUserToken() {
    const payload = {
      phone: this.step1Form.get('mobile').value,
      extension: this.extn,
      firebase_response: this.firebase_response
    };
    this.authService.loginOTPVerify(payload).subscribe({
      next: (res: any) => {
        this.signupService.afterLogin(res, 'medibuddy').then(val => {
          setTimeout(() => {
            this.patchLoginUserData();
          }, 1000);
          this.isLoading = false;
        });
      },
      error: (error) => {
        this.isLoading = false;
      }
    });
  }

  registerUser() {
    const user_payload = {
      full_name: this.step1Form.get('name').value,
      email_id: this.step1Form.get('email').value,
      extension: this.extn,
      phone_1: this.step1Form.get('mobile').value,
      password: 'Ketto123',
      invisible_recaptcha: true,
      user_type: 'individual',
      registration_source: 'direct',
      'g-recaptcha-response': '',
      is_subscribed: '1'
    };

    this.isLoading = true;
    this.vars.pageName = 'healthfirst_calculator'
    this.sendEvent({
      eventName: 'step_completed',
      page_name: 'healthfirst_calculator',
      info_1: 'step 1',
    });
    this.events.claverTapPush('Healthfirst calculator step 1', {
      'Event Name': 'step_completed',
      'info_1': `step ${this.step}`,
    })
    this.authService.register(user_payload, true).subscribe({
      next: (res: any) => {
        this.verifyUserToken();
      },
      error: (err) => { 
        this.util.openSnackBar(err?.error?.message, 'error');
        this.isLoading = false;
      }
    });
  }

  sendOtp() {
    if (this.util.isBrowser) {
      const appVerifier = (<any>window).recaptchaVerifier;
      const auth = getAuth(initializeApp(environment.firebase));
      this.otpSentTo = this.step1Form.get('mobile').value;
      signInWithPhoneNumber(auth, this.extn + this.step1Form.get('mobile').value, appVerifier).then(result => {
        this.sendOtpClicked = true;
        this.isLoading = false;
        (<any>window).confirmationResult = result;
        this.util.openSnackBar('OTP has been sent to your number ' + this.step1Form.get('mobile').value, 'success');
        this.toggleOtp(true);
        if (this.isNewUser) {
          this.toggleSignupForm();
        } 
      }).catch(error => {
        this.isLoading = false;
        this.util.openSnackBar(error.message + ': ' + error.code, 'error');
      });
    }
  }

  toggleOtp(status = false) {
    this.showOtp = status;
    if (status) {
      this.step1Form.get('otp').enable();
      this.sendOtpClicked = true;
    } else {
      this.sendOtpClicked = false;
      this.step1Form.get('otp').disable();
    }
  }

  toggleSignupForm() {
    this.showSignupForm = this.isNewUser;
    if (this.isNewUser) {
      this.step1Form.get('name').enable();
      this.step1Form.get('email').enable();
    } else {
      this.step1Form.get('name').disable();
      this.step1Form.get('email').disable();
    }
  }

  onMobileChange() {
    this.step1Form.get('mobile')?.valueChanges.subscribe((res: string) => {
      if (res && res === this.otpSentTo) {
        this.toggleOtp(true);
      } else if (!res || res !== this.otpSentTo) {
        this.toggleOtp(false);
        if (this.step1Form.get('name')) {
          this.isNewUser = false;
          this.toggleSignupForm();
        }
      }
    });
  }

  onNameAddStep2(event, index) {
    if (event === '') {
      this.step2Form.controls[index].get('age').removeValidators([Validators.required]);
      this.step2Form.controls[index].get('age').updateValueAndValidity();
      this.step2Form.controls[index].get('age').markAsUntouched();
      
      this.step2Form.controls[index].get('heightFt').removeValidators([Validators.required]);
      this.step2Form.controls[index].get('heightFt').updateValueAndValidity();
      this.step2Form.controls[index].get('heightFt').markAsUntouched();

      this.step2Form.controls[index].get('heightInch').removeValidators([Validators.required]);
      this.step2Form.controls[index].get('heightInch').updateValueAndValidity();
      this.step2Form.controls[index].get('heightInch').markAsUntouched();

      this.step2Form.controls[index].get('weight').removeValidators([Validators.required]);
      this.step2Form.controls[index].get('weight').updateValueAndValidity();
      this.step2Form.controls[index].get('weight').markAsUntouched();


    } else if (index > 0) {
      this.step2Form.controls[index].get('age').addValidators([Validators.required]);
      this.step2Form.controls[index].get('age').updateValueAndValidity();
      
      this.step2Form.controls[index].get('heightFt').addValidators([Validators.required]);
      this.step2Form.controls[index].get('heightFt').updateValueAndValidity();
      
      this.step2Form.controls[index].get('heightInch').addValidators([Validators.required]);
      this.step2Form.controls[index].get('heightInch').updateValueAndValidity();
      
      this.step2Form.controls[index].get('weight').addValidators([Validators.required]);
      this.step2Form.controls[index].get('weight').updateValueAndValidity();
    }
  }

  incrementStep() {
    if (this.step < 3) {
      this.step = this.step + 1;
      this.util.scrollToTop();
      const stepfn = {
        0: 5,
        1: 30,
        2: 70,
        3: 90
      }
      this.progressBarValue = stepfn[this.step];
    } else {
      this.submitForm();
    }
  }

  submitForm() {
    let values = this.step2Form.value;
    values = values.filter(item => item.name !== '' && item.age !== null && item.heightFt !== null && item.heightInch !== null && item.weight !== null);
    if (values) {
      const height = values[0].heightFt + '.' + values[0].heightInch;
      let payload = {
        family : values.length,
        does_anyone_in_your_family_smokes: this.step4Form.get('anySmoker').value,
        any_drinkers_in_your_family: this.step4Form.get('anyDrinker').value,
        anyone_in_the_family_using_tobacco: this.step4Form.get('anyTobacco').value,
        avg_spends_on_medical: this.step3Form.get('avgSpendsOnMedicine').value,
        annual_clinic_visits: isNaN(this.step3Form.get('annualClinicVisit').value) ? '5' : this.step3Form.get('annualClinicVisit').value,
        avg_spends_on_lab_test: this.step3Form.get('avgSpendsOnLabTest').value,
        weight:values[0].weight,
        height
      }
      this.hfService.postHfCalculatorData(payload).subscribe(val => {
        if (val) {
          this.hfService.calculatorData = val.data;
          this.router.navigate(['/healthfirst/risk-meter']);
        }
      })
    }
  }

  verifyUserDetails() {
    this.isLoading = true;
    const payload = {
      phone: this.step1Form.get('mobile').value,
      extension: this.extn,
      showError: 'false'
    };
    if (!this.sendOtpClicked) {
      const payload = {
        eventName: 'Signin Get OTP clicked',
        event_type: 'signin'
      }
      this.events.sendSystemEvent(payload).subscribe(_ => _);
    }
    this.authService.verifyUserDetails(payload).subscribe({
      next: (resp) => {
        this.isNewUser = false;
        this.sendOtp();
      },
      error: (err) => {
        if ((/Invalid details/).test(err?.error?.message)) {
          this.isNewUser = true;
          this.sendOtp();
        } else {
          this.isLoading = false;
        }
      }
    });
  }

  checkForm() {
    return new Promise((resolve, reject) => {
      const stepfunc = {
        0: () => this.step1Form.valid ? resolve(true): reject(false),
        1: () => this.step2Form.valid ? resolve(true): reject(false),
        2: () => this.step3Form.valid ? resolve(true): reject(false),
        3: () => this.step4Form.valid ? resolve(true): reject(false),
      }
      stepfunc[this.step]();
    });
  }

  openDialog() {
    this.bottomSheetType = 'dob';
    this.bottomSheet.open(this.bottomSheetRef);
  }

  toggleDatePicker(item, picker) {
    picker.open();
    item.isDateOpen = !item.isDateOpen;
  }

  sendEvent(payload) {
    this.events.sendSystemEvent(payload).subscribe(_ => _);
  }

  ngOnDestroy() {
    if (typeof window !== 'undefined') {
      document.body.style.overflowX = 'hidden';
    }
  }
}
